import React from "react";

export default function ProcessArchitecture() {
    const Card = ({ title, desc }) => (
        <div className="card">
            <div className="card-title">{title}</div>
            <div className="card-desc">{desc}</div>
        </div>
    );

    return (
        <>
            <style>{`
        .page {
          background: #eef2f7;
          min-height: 100vh;
          padding: 60px 20px;
          font-family: "Segoe UI", sans-serif;
        }

        .container {
          max-width: 1200px;
          margin: auto;
        }

        .section {
          text-align: center;
          margin-bottom: 50px;
        }

        .section-title {
          font-size: 26px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .section-subtitle {
          font-size: 14px;
          color: #666;
        }

        .row {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 25px;
          margin: 30px 0;
        }

        .card {
          width: 220px;
          background: white;
          border-radius: 14px;
          padding: 20px;
          box-shadow: 0 8px 18px rgba(0,0,0,0.07);
          border-top: 4px solid #1b8e4d;
          transition: 0.3s ease;
        }

        .card:hover {
          transform: translateY(-6px);
          box-shadow: 0 14px 25px rgba(0,0,0,0.12);
        }

        .card-title {
          font-weight: 600;
          font-size: 16px;
          margin-bottom: 8px;
          color: #1b1b1b;
        }

        .card-desc {
          font-size: 13px;
          color: #666;
        }

        .arrow-down {
          text-align: center;
          font-size: 22px;
          color: #1b8e4d;
        }

        @media(max-width: 768px) {
          .row {
            flex-direction: column;
            align-items: center;
          }
        }
      `}</style>

            <div className="page">
                <div className="container">

                    <div className="section">
                        <div className="section-title">Training Process Architecture</div>
                        <div className="section-subtitle">
                            Complete structured workflow from Department to Trainer
                        </div>
                    </div>

                    {/* Level 1 */}
                    <div className="row">
                        <Card title="Department" desc="Top level organizational unit managing programs." />
                        <Card title="Funder" desc="Financial sponsor supporting project execution." />
                        <Card title="Project" desc="Scheme or training program under funder." />
                        <Card title="Centre" desc="Training location assigned under project." />
                    </div>

                    <div className="arrow-down">⬇</div>

                    {/* Level 2 */}
                    <div className="row">
                        <Card title="Batch" desc="Student batch created under specific centre." />
                        <Card title="Candidate Details" desc="Student enrollment and profile records." />
                    </div>

                    <div className="arrow-down">⬇</div>

                    {/* Level 3 */}
                    <div className="row">
                        <Card title="Mobilization" desc="Candidate sourcing and onboarding process." />
                        <Card title="Enrollment Verification" desc="Document and eligibility validation." />
                    </div>

                    <div className="arrow-down">⬇</div>

                    {/* Level 4 */}
                    <div className="row">
                        <Card title="Course" desc="Training curriculum assigned to batch." />
                        <Card title="Assessor" desc="Examiner assigned for assessment." />
                        <Card title="Trainer" desc="Instructor conducting training sessions." />
                    </div>

                </div>
            </div>
        </>
    );
}

// import React, { useState } from "react";

// export default function MenuPages() {
//     const [activeStep, setActiveStep] = useState(1);

//     const steps = [
//         "Create Academic Session",
//         "Add Classes",
//         "Add Sections",
//         "Add Students",
//         "Configure Fees",
//         "Generate Reports",
//     ];

//     return (
//         <>
//             <style>{`
//         .container {
//           padding: 40px;
//           background: #f5f6fa;
//           min-height: 100vh;
//           font-family: Arial, sans-serif;
//         }

//         .title {
//           font-size: 24px;
//           font-weight: bold;
//           margin-bottom: 40px;
//         }

//         .step-wrapper {
//           display: flex;
//           flex-wrap: wrap;
//           align-items: center;
//           gap: 20px;
//         }

//         .step-item {
//           display: flex;
//           align-items: center;
//           cursor: pointer;
//           transition: 0.3s;
//         }

//         .circle {
//           width: 45px;
//           height: 45px;
//           border-radius: 50%;
//           background: #e0e0e0;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           transition: 0.3s;
//         }

//         .step-item.active .circle {
//           background: #1b8e4d;
//           color: white;
//         }

//         .step-item.completed .circle {
//           background: #4caf50;
//           color: white;
//         }

//         .step-label {
//           margin-left: 10px;
//           font-weight: 500;
//         }

//         .line {
//           height: 3px;
//           width: 50px;
//           background: #ccc;
//         }

//         @media (max-width: 768px) {
//           .step-wrapper {
//             flex-direction: column;
//             align-items: flex-start;
//           }

//           .line {
//             display: none;
//           }
//         }
//       `}</style>

//             <div className="container">
//                 <div className="title">Setup Process</div>

//                 <div className="step-wrapper">
//                     {steps.map((step, index) => {
//                         const stepNumber = index + 1;
//                         const isActive = stepNumber === activeStep;
//                         const isCompleted = stepNumber < activeStep;

//                         return (
//                             <React.Fragment key={step}>
//                                 <div
//                                     className={`step-item ${isActive ? "active" : ""
//                                         } ${isCompleted ? "completed" : ""}`}
//                                     onClick={() => setActiveStep(stepNumber)}
//                                 >
//                                     <div className="circle">{stepNumber}</div>
//                                     <div className="step-label">{step}</div>
//                                 </div>

//                                 {index !== steps.length - 1 && <div className="line" />}
//                             </React.Fragment>
//                         );
//                     })}
//                 </div>
//             </div>
//         </>
//     );
// }


// // import React from "react";

// // export default function MenuPages() {
// //     const menus = [
// //         "Dashboard",
// //         "Students",
// //         "Teachers",
// //         "Attendance",
// //         "Fees",
// //         "Reports",
// //         "Settings",
// //     ];

// //     return (
// //         <>
// //             <style>{`
// //         .page-container {
// //           padding: 30px;
// //           background: #f5f6fa;
// //           min-height: 100vh;
// //           font-family: Arial, sans-serif;
// //         }

// //         .page-title {
// //           margin-bottom: 30px;
// //           font-size: 24px;
// //           font-weight: bold;
// //         }

// //         .card-grid {
// //           display: grid;
// //           grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
// //           gap: 20px;
// //         }

// //         .menu-card {
// //           background: white;
// //           padding: 20px 20px;
// //           border-radius: 12px;
// //           text-align: center;
// //           font-size: 18px;
// //           font-weight: 600;
// //           cursor: pointer;
// //           transition: all 0.3s ease;
// //           box-shadow: 0 4px 12px rgba(0,0,0,0.06);
// //         }

// //         .menu-card:hover {
// //           transform: translateY(-5px);
// //           box-shadow: 0 8px 20px rgba(0,0,0,0.1);
// //           background: #1b8e4d;
// //           color: white;
// //         }

// //         @media (max-width: 600px) {
// //           .menu-card {
// //             padding: 30px 15px;
// //             font-size: 16px;
// //           }
// //         }
// //       `}</style>

// //             <div className="page-container">
// //                 <div className="page-title">Management Panel</div>

// //                 <div className="card-grid">
// //                     {menus.map((menu) => (
// //                         <div
// //                             key={menu}
// //                             className="menu-card"
// //                             onClick={() => alert(`${menu} Clicked`)}
// //                         >
// //                             {menu}
// //                         </div>
// //                     ))}
// //                 </div>
// //             </div>
// //         </>
// //     );
// // }